import React from 'react'
import c from 'classnames'

import Collection from 'components/widgets/Collection'
import { Add } from 'components/config/quote/Additions'
import { initialAdd } from 'reducers/quoteReducers'

export default function Warranties({
  items,
  addItem,
  removeItem,
  editValue,
  hideHelp,
  hideRemove,
  usingMdrive,
}) {
  return (
    <section className="quote-fees">
      <h3>Warranties</h3>
      {!hideHelp && (
        <article className="message is-info is-small">
          <div className="message-body">Lorem ipsum...</div>
        </article>
      )}
      {['warranties'].map(s => (
        <Collection
          key={s}
          hideRemove={hideRemove}
          className={c(
            'quote-config-collection',
            `quote-config-collection-${s}`,
          )}
          items={items}
          addItem={addItem(s, { ...initialAdd })}
          removeItem={removeItem(s)}
          addButtonLabel="Add Warranty"
          itemRenderer={(item, index, items) => (
            <Add
              {...{ item, index, items, usingMdrive }}
              editValue={editValue(s)}
            />
          )}
        />
      ))}
    </section>
  )
}
